import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { MoreVert as MoreVertIcon } from '@vedmarket/ui-kit';

import { useCalculationReadOnly } from '../../cabinet/calculator/calculation-read-only';
import LockedIconButton from '../locked-icon-button';

import './menu-button.scss';

type MenuOption = {
    title: string
    onClick(): void,
}

type Props = {
    options: MenuOption[];
}

const ITEM_HEIGHT = 48;

const MenuButton = ({options} : Props) => {

  const readOnly = useCalculationReadOnly();

  const [ anchorEl, setAnchorEl ] = React.useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  if (readOnly) {
    return (
      <LockedIconButton className='menu-button_locked'>
        <MoreVertIcon />
      </LockedIconButton>
    );
  }

  const handleClose = (option: MenuOption) => {
    setAnchorEl(null);
    option.onClick && option.onClick();
  };

  return (
    <div>
      <IconButton
        aria-label='more'
        id='long-button'
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup='true'
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id='long-menu'
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch',
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.title} onClick={() => handleClose(option)}>
            {option.title}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default MenuButton
